import {useQuery} from '@tanstack/react-query';

import {getRequest} from '../utils/httpClient';

export type Track = {id: string; title: string; file: string};

export const useMusicTracks = (): Track[] =>
    useQuery({
        queryKey: ['music'],
        queryFn: () => getRequest<{tracks: Track[]}>('/audio/manifest.json'),
        staleTime: Number.POSITIVE_INFINITY,
    }).data?.tracks ?? [];

/** The picker's "Random" choice: the presenter picks a track when it loads. */
export const RANDOM_TRACK_ID = 'random';

/** The track a ballot plays: the one it names, any one for Random, or none. */
export const resolveTrack = (
    tracks: Track[],
    id: string | null | undefined,
    pick: (count: number) => number = (count) => Math.floor(Math.random() * count),
): Track | null => {
    if (id === RANDOM_TRACK_ID) return tracks.length > 0 ? tracks[pick(tracks.length)] : null;
    return tracks.find((t) => t.id === id) ?? null;
};
